import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserType } from 'store/api/apiTypes';

interface UserInfo {
  email: string | null;
  name: string | null;
  sub: string | null;
}

interface UserState {
  user: UserInfo | null;
}

interface UserSliceState extends UserState {
  showSubBanner: boolean;
  userType: UserType | null;
}

const initialState: UserSliceState = {
  user: null,
  showSubBanner: false,
  userType: null,
};
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserInfo>) => {
      console.log('Setting user in state:', action.payload);
      state.user = action.payload;
    },
    clearUser: state => {
      state.user = null;
    },
    setShowBanner: (state, action: PayloadAction<boolean>) => {
      state.showSubBanner = action.payload;
    },
    setUserType: (state, action: PayloadAction<UserType>) => {
      state.userType = action.payload;
    },
  },
});

export const { setUser, clearUser, setShowBanner, setUserType } =
  userSlice.actions;
export default userSlice.reducer;
